export const sumGameProgress = (prev: string, next: string): string => {
  const prevResult = prev.split('/')[0];
  const prevMax = prev.split('/')[1];
  const nextResult = next.split('/')[0];
  const nextMax = next.split('/')[1];
  if (!(prevResult && prevMax && nextResult && nextMax)) return 'Error';
  return `${Number(prevResult) + Number(nextResult)}/${Number(prevMax) + Number(nextMax)}`;
};
